import RecentActorsOutlinedIcon from "@mui/icons-material/RecentActorsOutlined";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';

const KotClientMenus = (basePath) => [
  {
    label: "sidebar.menu.kot",
    type: "section",
    children: [
      {
        uri: `${basePath}/client-details`,
        label: "sidebar.menuItem.client.client-details",
        type: "nav-item",
        icon: <RecentActorsOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: `${basePath}/licensed-families`,
        label: "sidebar.menuItem.client.licensed-families",
        type: "nav-item",
        icon: <GroupsOutlinedIcon  sx={{ fontSize: 20 }} />,
      },
      {
        label: "sidebar.menuItem.client.shadowing",
        type: "collapsible",
        icon: <AutoStoriesOutlinedIcon sx={{ fontSize: 20 }} />,
        children: [
          {
            uri: `${basePath}/status-by-family`,
            label: "sidebar.menuItem.client.status-by-family",
            type: "nav-item",
          },
          {
            uri: `${basePath}/paralegal-instructions`,
            label: "sidebar.menuItem.client.paralegal-instructions",
            type: "nav-item",
          },
          {
            uri: `${basePath}/pps-instructions`,
            label: "sidebar.menuItem.client.pps-instructions",
            type: "nav-item",
          },
        ],
      },
      {
        uri: `${basePath}/recurring-actions`,
        label: "sidebar.menuItem.client.recurring-actions",
        type: "nav-item",
        icon: <FileCopyOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: `${basePath}/foreign-associates`,
        label: "sidebar.menuItem.client.foreign-associates",
        type: "nav-item",
        icon: <PeopleAltOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: `${basePath}/inventors`,
        label: "sidebar.menuItem.client.inventors",
        type: "nav-item",
        icon: <LightbulbOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: `${basePath}/billing`,
        label: "sidebar.menuItem.client.billing",
        type: "nav-item",
        icon: <ReceiptOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: `${basePath}/client-preferences`,
        label: "sidebar.menuItem.client.client-preferences",
        type: "nav-item",
        icon: <TuneOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: `${basePath}/attorney-preferences`,
        label: "sidebar.menuItem.client.attorney-preferences",
        type: "nav-item",
        icon: <MenuBookOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: `${basePath}/annuties`,
        label: "sidebar.menuItem.client.annuties",
        type: "nav-item",
        icon: <ReceiptLongOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: `${basePath}/additional-info`,
        label: "sidebar.menuItem.client.additional-info",
        type: "nav-item",
        icon: <PostAddOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: `${basePath}/working-team`,
        label: "Working Team",
        type: "nav-item",
        icon: <GroupAddOutlinedIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },
];

export default KotClientMenus;
